import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";
import {
  FaFacebookF,
  FaPinterestP,
  FaEnvelope,
  FaInstagram,
  FaYoutube,
  FaLinkedinIn,
  FaWhatsapp,
  FaArrowUp,
  FaPhone,
} from "react-icons/fa";
import "./footer.css";

const Footer = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant", // or "smooth"
    });
  }, [pathname]);

  return (
    <>
      <footer className="footer-section lexend ">
        <Container fluid>
          {/* DESKTOP VIEW */}
          <Row className="d-none d-md-flex ">
            <Col md={4}>
              <motion.div
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
              >
                <NavLink to="/">
                  <img
                    src="/images/native.png"
                    alt="Native91"
                    className="footer-logo"
                  />
                </NavLink>

                <p className="footer-text">
                  Native91 is a curated marketplace for discovering and shopping
                  exceptional homegrown Indian brands. Explore thoughtfully made
                  products across home, lifestyle, fashion, beauty, food,
                  gifting, and more, while supporting the people and stories
                  behind them.
                </p>
                <div className="d-flex align-items-center gap-2">
                  <img
                    src="/images/india.png"
                    alt="Refresh"
                    className="footer-logo w-50"
                    // onClick={refreshPage}
                  />{" "}
                  {/* <img
                    src="/images/brandel.png"
                    alt="Refresh"
                    className="footer-logo w-50"
                    onClick={refreshPage}
                  /> */}
                </div>
              </motion.div>
            </Col>

            <Col md={2}>
              <h5 className="lexend">INFO</h5>
              <ul className="footer-links">
                {/* <li>
                  <NavLink to="/aboutus">Our Story</NavLink>
                </li> */}
                <li>
                  <NavLink to="/contactus">Contact Us</NavLink>
                </li>
                <li>
                  {/* <NavLink to="/track-order">Track Order</NavLink> */}
                </li>
                <li>
                  <NavLink to="/faqs">User FAQ</NavLink>
                </li>
                <li>
                  <NavLink to="/faqseller">Seller FAQ</NavLink>
                </li>
                <li>
                  <NavLink to="/orderhistory">Order History</NavLink>
                </li>
              </ul>
            </Col>

            <Col md={3}>
              <h5 className="lexend">OUR PROGRAMS</h5>
              <ul>
                <li className="footer-links">
                  <NavLink to="#"> E-Gift Voucher</NavLink>
                </li>
                <li className="footer-links">
                  <NavLink to="/social-impact"> Social Impact</NavLink>
                </li>
                <li className="footer-links">
                  <NavLink to="/careers"> Careers</NavLink>
                </li>
              </ul>
              <div className="d-flex align-items-center gap-3 mt-4 social-icons">
                <h5 className="mb-0 lexend ">FOLLOW US ON</h5>

                <a
                  href="https://www.instagram.com/native91.official?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw=="
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Follow us on Instagram"
                >
                  <FaInstagram />
                </a>
              </div>{" "}
              <div className="social-icons">
                {/* <a href="https://facebook.com" target="_blank">
                  <FaFacebookF />
                </a>
                <a href="https://pinterest.com" target="_blank">
                  <FaPinterestP />
                </a> */}
                {/* <a
                  href="https://www.instagram.com/native91.official?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw=="
                  target="_blank"
                >
                  <FaInstagram />
                </a> */}
                {/* <a href="mailto:support@native91.com" target="_blank">
                  <FaEnvelope />
                </a>
                <a href="tel:+919998323998" target="_blank">
                  <FaPhone />
                </a> */}
              </div>
            </Col>

            <Col md={3}>
              <h5 className="lexend">POLICY</h5>
              <ul className="footer-links">
                <li>{/* <NavLink to="/disclaimer">Disclaimer</NavLink> */}</li>

                <li>
                  <NavLink to="/terms-and-conditions">
                    Terms & Conditions
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/shipping-policy">Shipping Policy</NavLink>
                </li>

                <li>
                  <NavLink to="/return-policy">
                    Return, Refund & Cancellation
                  </NavLink>
                </li>

                <li>
                  <NavLink to="/privacypolicy">Privacy Policy</NavLink>
                </li>
              </ul>
            </Col>

            {/* <hr /> */}
            <p className="text-center mb-0">
              Copyright © 2026 Native91. All rights reserved.
            </p>
          </Row>

          {/* MOBILE VIEW */}
          {/* MOBILE VIEW */}
          <Row className="d-md-none">
            <Col>
              {/* LOGO */}
              <NavLink to="/">
                <img
                  src="/images/native.png"
                  alt="Native91"
                  className="footer-logo"
                />
              </NavLink>

              {/* TEXT (FULL TEXT LIKE SCREENSHOT) */}
              <p className="footer-text">
                Native91 is a curated marketplace for discovering and shopping
                exceptional homegrown Indian brands. Explore thoughtfully made
                products across home, lifestyle, fashion, beauty, food, gifting,
                and more, while supporting the people and stories behind them.
              </p>
              <div className="d-flex align-items-center gap-2">
                <img
                  src="/images/india.png"
                  alt="Refresh"
                  className="footer-logo w-50"
                />{" "}
                {/* <img
                    src="/images/brandel.png"
                    alt="Refresh"
                    className="footer-logo w-50"
                    onClick={refreshPage}
                  /> */}
              </div>

              {/* MOBILE MENU */}
              <div className="mobile-footer">
                <details>
                  <summary>INFO</summary>
                  <div className="mobile-footer-content">
                    <ul className="footer-links">
                      {/* <li>
                        <NavLink to="/aboutus">Our Story</NavLink>
                      </li> */}
                      <li>
                        <NavLink to="/contactus">Contact Us</NavLink>
                      </li>
                      <li>
                        {/* <NavLink to="/track-order">Track Order</NavLink> */}
                      </li>
                      <li>
                        <NavLink to="/faqs">User FAQ</NavLink>
                      </li>
                      <li>
                        <NavLink to="/faqseller">Seller FAQ</NavLink>
                      </li>
                      <li>
                        <NavLink to="/orderhistory">Order History</NavLink>
                      </li>
                    </ul>
                  </div>
                </details>

                <details>
                  <summary>OUR PROGRAMS</summary>
                  <ul>
                    <li className="footer-links">
                      <NavLink to="#"> E-Gift Voucher</NavLink>
                    </li>
                    <li className="footer-links">
                      <NavLink to="/social-impact"> Social Impact</NavLink>
                    </li>
                    <li className="footer-links">
                      <NavLink to="/careers"> Careers</NavLink>
                    </li>
                  </ul>
                </details>

                <details>
                  <summary>POLICY</summary>
                  <div className="mobile-footer-content">
                    <ul className="footer-links">
                      <li>
                        {/* <NavLink to="/disclaimer">Disclaimer</NavLink> */}
                      </li>

                      <li>
                        <NavLink to="/terms-and-conditions">
                          Terms & Conditions
                        </NavLink>
                      </li>

                      <li>
                        <NavLink to="/shipping-policy">Shipping Policy</NavLink>
                      </li>

                      <li>
                        <NavLink to="/return-policy">
                          Return, Refund & Cancellation
                        </NavLink>
                      </li>

                      <li>
                        <NavLink to="/privacypolicy">Privacy Policy</NavLink>
                      </li>
                    </ul>
                  </div>
                </details>

                <details>
                  <summary>FOLLOW US ON</summary>
                  <div className="mobile-footer-content">
                    <div className="social-icons">
                      {/* <a href="https://facebook.com" target="_blank">
                        <FaFacebookF />
                      </a>
                      <a href="https://pinterest.com" target="_blank">
                        <FaPinterestP />
                      </a> */}
                      <a
                        href="https://www.instagram.com/native91.official?utm_source=ig_web_button_share_sheet&igsi=ZDNlZDc0MzIxNw=="
                        target="_blank"
                      >
                        <FaInstagram />
                      </a>
                      {/* <a href="https://youtube.com" target="_blank">
                        <FaYoutube />
                      </a>
                      <a href="https://linkedin.com" target="_blank">
                        <FaLinkedinIn />
                      </a> */}
                    </div>
                  </div>
                </details>
              </div>
            </Col>
          </Row>
        </Container>
      </footer>

      {/* WHATSAPP BUTTON */}
      <a
        href="https://wa.me/919998323998?text=Hello%20Native91,%20I%20have%20a%20query%20about%20your%20products."
        target="_blank"
        className="whatsapp-btn"
      >
        <FaWhatsapp />
      </a>

      {/* SCROLL TO TOP */}
      {/* <button className="scroll-top" onClick={scrollToTop}>
        <FaArrowUp />
      </button> */}
    </>
  );
};

export default Footer;
